import { PropsWithChildren } from 'react';

import { FormComponentProps } from './types';

const FormComponent = ({ onSubmit, className, children }: PropsWithChildren<FormComponentProps>) => {
  return (
    <form className={className} onSubmit={onSubmit}>
      {children}
    </form>
  );
};

export default FormComponent;
